@import '../../../constants/spacing.module.less';

.bulkResultsList {
  flex: 1;
  overflow-y: auto;
  border-right: 1px solid var(--grey-500);
  min-width: 300px;
}

.bulkResultsListItem {
  display: flex;
  gap: @space-12;
  padding: @space-16;
  border-bottom: 1px solid var(--grey-200);
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--grey-50);
  }

  &:focus {
    outline: 2px solid var(--blue-500);
    outline-offset: -2px;
  }
}

.bulkResultsListItemSelected {
  background-color: var(--blue-50);
  border-left: 9px solid var(--blue-500);
}

.bulkResultsListItemIcon {
  flex-shrink: 0;
  font-size: 20px;
  padding-top: 2px;
  > svg {
    width: 16px;
  }
}

.successIcon {
  color: var(--green-600);
}

.errorIcon {
  color: var(--red-600);
}

.acceptedIcon {
  color: var(--blue-500);
}

.needsReviewIcon {
  color: var(--grey-600);
}

.acceptedCode {
  color: var(--blue-600);
  font-weight: 600;
}

.bulkResultsListItemContent {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: @space-4;
}

.sidePanel {
  flex: 2;
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  min-width: 400px;
}

.sidePanelContent {
  flex: 1;
  overflow-y: auto;
  padding: @space-20;
}

.loadingContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
}

.modalBody {
  flex: 1;
  display: flex;
  min-height: 775px;
}

.modalFooter {
  display: flex;
  align-items: center;
}

.modalFooterStats {
  display: flex;
  gap: @space-24;
  flex-wrap: wrap;
  flex: 1;
}

.summaryBanner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: @space-16;
  background-color: var(--blue-100);
  border-bottom: 1px solid var(--blue-200);
  gap: @space-16;
}
